import { api } from 'app/api';

/**
 * @param {{ hspId:string, usrId:string, hsptlzRsvNo:string, contentVersion:string, contentCode:string, contentName:string,	contentDetailList: [{contentDetailCode:string, contentDetailYn: 'Y' | 'N'}]	}} params
 * @description I-15 입원 동의서 동의 내용 저장 API
 * @returns
 */
export const saveHsptlzFormCcrc = async (params, navigate) => {
  try {
    return await api.post(`/dfd/api/if/web/v1/hsptlz-form-sign-info-save`, params);
  } catch (error) {
    navigate('/hsptlz/form/complete', { replace: true, state: { isSuccess: false } });
  }
};
